module.exports = __webpack_public_path__ + "img/geographic-targeted.550e3406.png";